import React from 'react';
import { Spinner } from '@chakra-ui/react';
import { useGetFindingPhotosBySizeAndLocationForShare, useGetLocationFindingsForShare, } from '../../../../services/api/generated/client';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import { localise } from '../../../../services/lang/lang';
import { ErrorAwareAlertBox } from '../../ErrorAwareAlertBox/ErrorAwareAlertBox';
import FindingPanel from '../../FindingPanel/FindingPanel';
import NoResultsFoundWrapper from '../../NoResultsFoundIndicator/NoResultsFoundWrapper';
import ScrollableWrapper from '../ScrollableWrapper';
import { useInspectionDetailShareContext } from '../../../pages/upgrade/InspectionDetail/ShareInspection/InspectionDetailShareProvider';
import { useScrollTrigger } from '../../../../hooks/useScrollTrigger';
const LocationFindingsShareWrapper = ({ location, isExpanded }) => {
    const { token } = useInspectionDetailShareContext();
    const { hasStartedScrolling, handleScroll } = useScrollTrigger();
    const queriesEnabled = isExpanded && !!location.findings_count;
    const { data: response, isError, isLoading: isLoadingFindings, error, } = useGetLocationFindingsForShare(token, location.id, {
        query: {
            enabled: queriesEnabled,
            staleTime: Infinity,
        },
    });
    const { data: photosResponse, isLoading: isLoadingPhotos } = useGetFindingPhotosBySizeAndLocationForShare(token, location.id, 'small', {
        query: {
            enabled: queriesEnabled,
            staleTime: Infinity,
        },
    });
    const loadedPhotos = unwrapModel(photosResponse);
    const findings = unwrapModel(response);
    if (isError) {
        return (React.createElement(ErrorAwareAlertBox, { error: error, noun: localise('ERROR_NOUN_LOCATION_FINDINGS') }));
    }
    if (isLoadingFindings || isLoadingPhotos) {
        return React.createElement(Spinner, { "data-testid": "loading_spinner" });
    }
    if (!findings?.length) {
        return (React.createElement(NoResultsFoundWrapper, { mainText: localise('NO_FINDINGS'), subText: localise('NO_FINDINGS_LOCATION_DESCRIPTION'), useIcon: true }));
    }
    return (React.createElement(ScrollableWrapper, { onScroll: handleScroll }, findings.map((finding) => (React.createElement(FindingPanel, { kind: "location", key: finding.id, finding: finding, loadedPhotos: loadedPhotos, hasStartedScrolling: hasStartedScrolling })))));
};
export default LocationFindingsShareWrapper;
